export default __webpack_public_path__ + "static/media/bell-active.ea8ef42f.svg";